import { render } from "./pb-blocktextimage.vue?vue&type=template&id=cb2766e6"
import script from "./pb-blocktextimage.vue?vue&type=script&lang=js"
export * from "./pb-blocktextimage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__